import { ScrollTop } from "@/components/commons/ScrollTop";
import { SwitchAccountConfirmModal } from "@/features/auth/components/SwitchAccountConfirmModal";
import { background } from "@/theme/colors";
import { Box } from "@mui/material";
import { FC } from "react";
import { Outlet } from "react-router-dom";

export const LoginLayout: FC = () => {
  return (
    <Box width="100%" minHeight="100vh" display="flex" justifyContent="center" pt={13} pb={4} bgcolor={background.primary}>
      <ScrollTop />
      {/* Warn before discarding an active session (e.g. switching organizations); shows a loading
          screen instead of the login content while the confirmation is pending. */}
      <SwitchAccountConfirmModal>
        <Outlet />
      </SwitchAccountConfirmModal>
    </Box>
  );
};
